<template>
  <v-navigation-drawer
    app
    width="200"
    clipped
    dark
    class="nav-border"
    color="#f2f5f9"
    :temporary="tempBool"
    :permanent="permBool"
    v-model.sync="mobile"
    :mini-variant="miniDrawer"
  >
    <v-list dense nav data-cy="sideBar-links">
      <v-list-item
          v-if="
          (!route.meta?.requireRoles || route.meta?.requireRoles.every((role) => getRoles.includes(role)))
          "
        :class="
          ($route.path === (route.path || '/') || (route.path && $route.path.startsWith(route.path + '/'))) ? 'active-item' : ''
        "
        v-for="(route, index) in items"
        :key="index"
        @click.stop="navigateToPath(route.path || '/')"
      >
        <v-list-item-icon>
          <v-icon style="margin-right: -4px !important text-none" color="#003088">{{
            route.meta?.menuIcon
          }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="logo-color font-weight-bold">
            {{ route.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import store from "@/store/store";
import router from "@/router/router";
import { WEB_UI_VERSION } from "@/config/constants";

export default {
  props: ["smallerDrawer"],
  data() {
    return {
      version: WEB_UI_VERSION,
      miniDrawer: true,
      items: router.getRoutes().filter((route) => route.meta?.menuIcon),
      getRoles: store.getters.getRoles,
    };
  },
  mounted() {
    const localMiniDrawer = JSON.parse(localStorage.getItem("miniDrawer"));
    this.miniDrawer = !!localMiniDrawer;
  },
  methods: {
    changeLanguageClicked(selectedLanguage) {
      this.$i18n.locale = selectedLanguage;
      this.languageDialog = false;
      localStorage.setItem("selectedLanguage", JSON.stringify(selectedLanguage));
    },
    miniDrawerClicked() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        this.miniDrawer = !this.miniDrawer;
        localStorage.setItem("miniDrawer", JSON.stringify(this.miniDrawer));
      } else {
        this.miniDrawer = false;
      }
    },
    navigateToPath(path) {
      this.$router.push(path).catch(() => {});
    },
  },
  computed: {
    // If smaller screens show drawer temporary
    tempBool() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true, (this.smallerDrawer = false);
        case "sm":
          return true, (this.smallerDrawer = false);
        case "md":
          return true, (this.smallerDrawer = false);
        case "lg":
          return false;
        case "xl":
          return false;
      }
    },
    // If bigger screens show drawer permanently
    permBool() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return false;
        case "sm":
          return false;
        case "md":
          return false;
        case "lg":
          return true;
        case "xl":
          return true;
      }
    },
    mobile: {
      // Getter
      // Retrieve value
      get: function () {
        return this.smallerDrawer;
      },
      // Setter
      // Change value
      set: function (newVal) {
        this.$emit("update:smallerDrawer", newVal);
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/style/main.scss";
//$nexusLightBorder
.nav-border {
  border-right: 2px solid #d6deec !important;
  top: 4.5rem !important;
}
.logo-color {
  color: #003088;
}
.second-heading-size {
  font-size: 0.95rem;
}
.version-style {
  color: #4f4f4f;
  font-size: 0.75rem;
}
.language-flags {
  width: 90px;
  cursor: pointer;
  border: #191c3a solid 3px;
}
.language-flags:hover {
  opacity: 0.8;
}
.active-item {
  background-color: #d6deec;
}
.v-icon{
  margin-left: -.25em;
}
</style>
